export default __webpack_public_path__ + "static/media/insta_3.e885b466.svg";